import Axios from "axios";
import config from "config";

const returnError = (err) => {
  console.log(err);
  const data = {
    success: false,
    code: 5001,
    message: "There is a problem",
  };
  return data;
};

export const storeNewOrder = async (newData, image, token) => {
  try {
    const formData = new FormData();
    formData.append("data", JSON.stringify(newData));
    formData.append("image", image);
    const url = `${config.apiserver}/order/createneworder/`;
    const result = await Axios.post(url, formData, {
      headers: {
        "x-access-token": token,
      },
    });
    return result.data;
  } catch (err) {
    return returnError(err);
  }
};

export const updateOrder = async (newData, image, token) => {
  try {
    const formData = new FormData();
    formData.append("data", JSON.stringify(newData));
    formData.append("image", image);
    const url = `${config.apiserver}/order/updateorder/`;
    const result = await Axios.post(url, formData, {
      headers: {
        "x-access-token": token,
      },
    });
    return result.data;
  } catch (err) {
    return returnError(err);
  }
};
export const updateOrderPin = async (newData, token) => {
  try {
    const url = `${config.apiserver}/order/updateOrderPin/`;
    const result = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    return result.data;
  } catch (err) {
    return returnError(err);
  }
};
export const RemoveOrderImage = async (newData, token) => {
  try {
    const url = `${config.apiserver}/order/removeOrderImages/`;
    const result = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    return result.data;
  } catch (err) {
    return returnError(err);
  }
};
export const updateOrderCancel = async (newData, token) => {
  try {
    const url = `${config.apiserver}/order/canceleOrder/`;
    const result = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    return result.data;
  } catch (err) {
    return returnError(err);
  }
};
export const getOrdersList = async (perpage, page, search, filter, sort, token) => {
  try {
    const url = `${config.apiserver}/order/getorders/`;
    const newDatas = {
      perpage,
      page,
      search,
      filter,
      sort,
    };
    const result = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
    return result.data;
  } catch (err) {
    return returnError(err);
  }
};
export const getOrder = async (newData, token) => {
  try {
    const url = `${config.apiserver}/order/getorder/`;

    const result = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    return result.data;
  } catch (err) {
    return returnError(err);
  }
};
 
export const uploadImages = async (order, file, token) => {
  try {
    const formData = new FormData();
    formData.append("image", file); 
    formData.append("order", order);
    const url = `${config.apiserver}/order/uploadimages/`;
    const result = await Axios.post(url, formData, {
      headers: {
        "x-access-token": token,
      },
    });
    return result.data;
  } catch (err) {
    return returnError(err);
  }
};

export const getOrderLogList = async (newDatas, token) => {
  try {
    const url = `${config.apiserver}/order/getOrderLog/`;
    
    const result = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
     return result.data;
  } catch (err) {
    return returnError(err);
  }
};
export const getCollaboratorWagesList = async (perpage, page, search, filter, sort, token) => {
  try {
    const url = `${config.apiserver}/order/getcollaboratorwages/`;
    const newDatas = {
      perpage,
      page,
      search,
      filter,
      sort,
    };
    const result = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
     return result.data;
  } catch (err) {
    return returnError(err);
  }
};
export const getCollaboratorWagesDetailsList = async (
  perpage,
  page,
  search,
  filter,
  sort,
  collaborator,
  mode,
  token
) => {
  try {
    const url = `${config.apiserver}/order/getCollaboratorWagesDetails/`;
    const newDatas = {
      perpage,
      page,
      search,
      filter,
      sort,
      collaborator,
      mode
    };
    const result = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
     return result.data;
  } catch (err) {
    return returnError(err);
  }
};
